<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>监控中心</el-breadcrumb-item>
          <el-breadcrumb-item>编辑工单</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content-box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="基本信息" name="info">
            <div class="tab-content">
              <el-form
                ref="editForm1"
                :model="model"
                :rules="rules"
                :label-position="labelPosition"
                label-width="120px"
              >
                <el-form-item prop="companyId" label="设备编号">
                  <el-select
                    v-model="model.cabinetCode"
                    placeholder="请选择..."
                    style="width: 300px"
                  >
                    <el-option
                      v-for="role in cabinetList"
                      :key="role.cabinetCode"
                      :label="role.cabinetCode + ' (' + role.cabinetName + ')'"
                      :value="role.cabinetCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item prop="realName" label="工单标题">
                  <el-input v-model="model.title" placeholder=""></el-input>
                </el-form-item>
                <el-form-item prop="mobile" label="问题描述">
                  <textarea
                    v-model="model.description"
                    placeholder=""
                    style="padding: 10px"
                  ></textarea>
                </el-form-item>

                <el-form-item label="图片">
                  <el-upload
                    :action="uploadApi + '/cabinet/file/uploadImages'"
                    :headers="headers"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-success="handleSuccess"
                    :on-remove="handleRemove"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="" />
                  </el-dialog>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="footer-box">
        <div class="footer-btn">
          <el-button type="primary" @click="submitForm">确认保存</el-button>
          <el-button plain @click="resetForm">取消返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../js/upload.component.js";
import { AxiosAjax, uploadApi } from "../../js/axios.config";
export default {
  data() {
    return {
      headers: { Authorization: "" },
      uploadApi: uploadApi,
      dialogImageUrl: "",
      dialogVisible: false,

      disabled: true,
      activeName: "info", //当前选项卡
      labelPosition: "right", //表单对齐方式
      cabinetList: [],
      imgList: [],
      model: {
        cabinetCode: "",
        description: "",
        imgUrl: [],
        title: "",
      },
      rules: {
        realName: [
          { required: true, message: "请输入标题", trigger: "blur" },
          {
            min: 1,
            max: 128,
            message: "长度在 2 到 128 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.headers.Authorization = localStorage.getItem("fx_client_access_token");
  },
  methods: {
    handleSuccess(file, fileList) {
      this.imgList.push(file.data[0].relativePath);
      console.log("fileListss", file);
    },
    handleRemove(file, fileList) {
      this.imgList = [];
      console.log("fileList", fileList);
      fileList.forEach((el) => {
        this.imgList.push(el.response.data[0].relativePath);
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = false;
    },
    //初始化数据
    initData: function () {
      let _this = this; //当前页面
      // //加载设备
      AxiosAjax({
        url: "/cabinet/cabinet/search",
        loading: true,
        success: function (res) {
          _this.cabinetList = res.data.data;
        },
      });
    },
    submitForm: function () {
      let _this = this; //当前页面
      //多个表单验证
      _this.model.imgUrl = _this.imgList;
      AxiosAjax({
        method: "post",
        url: "/cabinet/workOrder/addWorkOrder",
        data: _this.model,
        loading: true,
        successMsg: "工单创建成功",
        success: function (res) {
          //重置表单
          _this.$router.push({ name: "WorkOrderList" });
        },
      });
    },
    resetForm() {
      window.history.back(-1);
    },
  },
  created: function () {
    //初始化数据
    this.initData();
  },
};
</script>
<style scoped>
.content-box {
  text-align: left !important;
}
textarea {
  width: 100%;
  height: 200px;
  border: 1px solid #dcdfe6;
}
.content-box
  /deep/
  .el-upload-list--picture-card
  .el-upload-list__item-thumbnail {
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/WorkOrder/WorkOrderEdit.vue